
import {filter} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { phfInfo } from './phf.config';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { AuthenticationService } from '../../auth.service';
import { AppService } from '../../app.service';
import { Location } from '@angular/common';
import { PHFUserService } from './phf.service';
import { RoleService, ModuleService } from '../../components/mesc/mesc.service';


@Component({
  selector: 'app-phf',
  templateUrl: './phf.component.html',
  styleUrls: ['./phf.component.scss']
})
export class PhfComponent implements OnInit {
  config: any = phfInfo;
  title: string;
  isAdminRoute: boolean;
  public userAdmin: any;

  constructor(
    public authService: AuthenticationService,
    public phfUserService: PHFUserService,
    public moduleService: ModuleService,
    public router: Router,
    private readonly location: Location,
    private readonly appService: AppService,
    public roleService: RoleService,

  ) { }

  ngOnInit() {
    this.router.events.pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: RouterEvent) => this.validateRoute(e.url));
    this.validateRoute(this.router.url);
    this.appService.viewTitle.subscribe(x => this.title = x);
  }


  /**
   * 
   */
  onBack = () => this.location.back();


  /** 
   * 
   */
  validateRoute = (url: string) => {
    const pathEnd = url.split('/').pop().replace('-', ' ');
    this.appService.viewTitle.next(pathEnd);
    this.isAdminRoute = pathEnd.toLowerCase().includes('admin');
  }

}
